import { render, staticRenderFns } from "./PEPersonalDetails.vue?vue&type=template&id=caf06f2c&scoped=true&"
import script from "./PEPersonalDetails.vue?vue&type=script&lang=js&"
export * from "./PEPersonalDetails.vue?vue&type=script&lang=js&"
import style0 from "./PEPersonalDetails.vue?vue&type=style&index=0&id=caf06f2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf06f2c",
  null
  
)

export default component.exports